(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sale-page"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
  const el = document.querySelector('.copy-wechat');

  if (!el) return;

  const tip = el.querySelector('.copy-tip');

  el.addEventListener('click', function () {
    const text = this.dataset.copy;

    navigator.clipboard.writeText(text)
      .then(() => {
        tip.textContent = 'Copied';

        setTimeout(() => {
          tip.textContent = 'Copy';
        }, 1500);
      });
  });
});

  } catch(e) { console.error(e); }
})();
})();
